export class Membro {
  id: number;
  telefone: string;
  tipoStatus: number;
  idNivel: number;
  origem: number;

  aceiteTermo: boolean;
  enviaComunicacao: boolean;
  queroSerLover: boolean;
  ativo: boolean;
  efetuadoLogin: boolean;
  visualizarPopupHome: boolean;
  emailValidado: boolean;
  telefoneValidado: boolean;

  nome: string;
  nomeSocial: string;
  cpf: string;
  genero: string;
  generoExtenso: string;
  email: string;
  senha: string;
  senhaConfirmacao: string;
  descricaoNivel: string;

  dataNascimento: Date;
  dataInclusao: Date;
  caminhoFoto: string;

  codigoPostal: string;
  pais: string;
  estado: string;
  cidade: string;
  bairro: string;
  endereco: string;
  complemento: string;
  numero: string;

  enderecosMembro: any[];
  atributos: any[];
}

export enum StatusMembro {
  ATIVO = 1,
  INATIVO = 2,
  FUNCIONARIO = 3,
  CPF_COM_USO_INDEVIDO = 4,
  CASHBACK_BLOQUEADO = 5,
  CADASTRO_EXCLUIDO = 6,
  SEM_ACEITE_COMUNICACAO = 7,
  DADOS_INVALIDOS = 8,
  NOVO = 11,
}
